import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalCrearTrabajadorPageRoutingModule } from './modal-crear-trabajador-routing.module';

import { ModalCrearTrabajadorPage } from './modal-crear-trabajador.page';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModalCrearTrabajadorPageRoutingModule
  ],
  declarations: [ModalCrearTrabajadorPage]
})
export class ModalCrearTrabajadorPageModule {}
